import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const subscriberScheduleApi = {
  /**
   * Get the configured email send time for a subscriber.
   * @param {number} userId
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<import('axios').AxiosResponse<import('../types/api').SubscriberSchedule>>}
   */
  get: (userId, config) => mod.get(`/subscribers/${userId}/schedule`, config),

  /**
   * Update send time and optional IANA timezone (e.g. Europe/Berlin).
   * @param {number} userId
   * @param {{ hour: number; minute: number; is_enabled: boolean; timezone?: string | null }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  put: (userId, body, config) =>
    mod.put(`/subscribers/${userId}/schedule`, body, config),

  /**
   * Manually trigger newsletter send for this subscriber right now.
   * @param {number} userId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  sendNow: (userId, config) =>
    mod.post(`/subscribers/${userId}/schedule/send-now`, null, config),
};
